import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

function isDayjsLike(value) {
  return value != null
    && typeof value === 'object'
    && typeof value.isValid === 'function'
    && typeof value.format === 'function';
}

/** Ant Design month picker value — always dayjs or null */
export function toMonthDayjs(value) {
  if (value == null || value === '') return null;
  if (isDayjsLike(value)) {
    return value.isValid() ? value.startOf('month') : null;
  }
  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.startOf('month') : null;
  }
  const s = String(value).trim();
  if (/^\d{4}-\d{2}$/.test(s)) {
    const d = dayjs(s, 'YYYY-MM', true);
    return d.isValid() ? d.startOf('month') : null;
  }
  const d = dayjs(s);
  return d.isValid() ? d.startOf('month') : null;
}

export function formatMonthKey(value) {
  const d = toMonthDayjs(value);
  return d ? d.format('YYYY-MM') : '';
}
